import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import VueMeta from 'vue-meta'
import moment from 'moment'

Vue.use(VueMeta, {
    // 定义组件中的数据对象
    keyName: 'head',
});

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.prototype.$moment = moment

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
